import React from 'react';
import {MenuItemRendererBase} from "../../../menu-items-common/renderer/menu-item-renderer-base";

import {IRenderMenuItemOptions} from "../../../menu-items-common/renderer/menu-item.renderer.interface";
import {
    IMenuItemConfigReader
} from "../../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";

/**
 * This class is for demonstrating how to override menu items per regulation. It should be removed when we will have a real case
 */
export class ItalyTestMenuItemRenderer extends MenuItemRendererBase {
    constructor( configReader: IMenuItemConfigReader,
                 services: IServiceFactoryExtended) {
        super('testRegulationSpecificMenuItem', configReader, services);
    }


    protected _createReactElement(options?: IRenderMenuItemOptions): React.ReactElement {
        return (
            <div key={this.key} style={{backgroundColor: "red", color: 'black'}} onClick={() => this.execute()}>
                {this.text}
            </div>
        )
    }

}